import { format } from 'owa-strings';
import { ITEM_URL } from '../utils/constants';
import { makeSDSNetworkCall } from './makeSDSNetworkCall';

export async function getSDSCollectionItems(collectionName: string): Promise<any> {
    return await makeSDSNetworkCall(format(ITEM_URL, collectionName), 'GET');
}
